import React from "react";
import Reveal from "@/components/Reveal";
import { useLocale } from "@/contexts/LocaleContext";
import { EditableT, EditableTLink, EditableImage } from "@/cms/EditableT";
import sauna1 from "@/assets/wellness/sauna-1.webp";

const WELLNESS_IMAGE = sauna1;

const WellnessSection: React.FC = () => {
  const { t } = useLocale();

  return (
    <section
      aria-labelledby="wellness-heading"
      className="mt-[120px] md:mt-[180px] lg:mt-[247px]"
    >
      <div className="mx-auto max-w-[1540px] px-6 md:px-10 lg:px-12 min-[1540px]:px-0">
        <div className="min-[1540px]:ml-auto min-[1540px]:max-w-[1311px] grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 lg:gap-[125px] items-center">
          {/* Text column */}
          <Reveal as="article" className="flex flex-col gap-[35px] max-w-[555px]">
            <header className="flex flex-col gap-[35px]">
              <span className="block font-['Kumbh_Sans'] text-[#383637] text-[15px] md:text-[17px] lg:text-[19px] font-normal uppercase tracking-[0.25em] leading-[1.32]">
                <EditableT k="home.wellness.kicker" />
              </span>
              <h2
                id="wellness-heading"
                className="font-['Kumbh_Sans'] text-[#383637] text-[28px] md:text-[36px] lg:text-[45px] font-extralight uppercase tracking-[0.05em] leading-[1.1] max-w-[420px] [text-wrap:balance]"
              >
                <EditableT k="home.wellness.headline" multiline />
              </h2>
            </header>
            <p className="font-['Baskervville'] text-[#383637] text-[17px] leading-[28px] tracking-[0.02em]">
              <EditableT k="home.wellness.text" multiline />
            </p>
            <EditableTLink
              k="home.wellness.cta_label"
              href="/wellness"
              className="self-start inline-flex items-center justify-center h-[37px] px-[30px] rounded-full bg-[#6C184F] leading-none hover:bg-[#581340] transition-colors text-[#F2F2F2] font-['Kumbh_Sans'] text-[14px] font-medium uppercase tracking-[0.08em]"
            />
          </Reveal>

          {/* Image column – <lg quadratisch */}
          <Reveal delay={150} className="group relative w-full aspect-square lg:aspect-[635/713] overflow-hidden">
            <EditableImage
              id="home.wellness.image"
              src={WELLNESS_IMAGE}
              alt={t("home.wellness.image_alt")}
              wrapperClassName="absolute inset-0 block w-full h-full"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.07]"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default WellnessSection;
